export class RatingViewModel {
  rating: number;
  complexRating: number;
  ratingBy: number;
  orderId: number;
}
